import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { SettingsQueryKey } from './queryKey';
import DataCacheService from '@/shared/services/DataCacheService';
export var useUpdateHrmSettings = function () {
    var intl = useIntl();
    var queryClient = useQueryClient();
    var _a = useMutation(function (_a) {
        var companyId = _a.companyId, model = _a.model;
        return api.base
            .put('/api/settings/hrm', model, { params: { id: companyId } })
            .then(function (res) { return res.data; });
    }, {
        onSuccess: function (_result, variables) {
            queryClient.setQueryData([SettingsQueryKey.HrmSettings, variables.companyId], variables.model);
            var _a = variables.model, registrationMinimumDate = _a.registrationMinimumDate, absenceMinimumDate = _a.absenceMinimumDate, allowRegistrationLocking = _a.allowRegistrationLocking;
            var propagated = {
                registrationMinimumDate: registrationMinimumDate,
                absenceMinimumDate: absenceMinimumDate,
                allowRegistrationLocking: allowRegistrationLocking,
            };
            DataCacheService.updateAllCompanies(propagated);
        },
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return { updateHrmSettings: mutateAsync, isLoading: isLoading };
};
